/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UsernameIndexRouteImport } from './routes/$username.index'
import { Route as UsernameSlugRouteImport } from './routes/$username.$slug'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppBillingRouteImport } from './routes/app/billing'
import { Route as AppBookingRouteImport } from './routes/app/booking'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppWelcomeRouteImport } from './routes/app/welcome'
import { Route as BookingTokenRouteImport } from './routes/booking.$token'
import { Route as ICodeRouteImport } from './routes/i.$code'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as LineSpikeRouteImport } from './routes/line.spike'
import { Route as LoginLinkRouteImport } from './routes/login_.link'
import { Route as AppAgreementsIndexRouteImport } from './routes/app/agreements/index'
import { Route as AppBookingIndexRouteImport } from './routes/app/booking/index'
import { Route as AppBookingAvailabilityRouteImport } from './routes/app/booking/availability'
import { Route as AppBookingCalendarsRouteImport } from './routes/app/booking/calendars'
import { Route as AppBookingInvitesRouteImport } from './routes/app/booking/invites'
import { Route as AppBookingPaymentsRouteImport } from './routes/app/booking/payments'
import { Route as AppClientsIndexRouteImport } from './routes/app/clients/index'
import { Route as AppInquiryIndexRouteImport } from './routes/app/inquiry/index'
import { Route as AppInvoicingIndexRouteImport } from './routes/app/invoicing/index'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppSettingsActivityRouteImport } from './routes/app/settings/activity'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/app/settings/integrations'
import { Route as AppSettingsMembersRouteImport } from './routes/app/settings/members'
import { Route as EmbedUsernameSlugRouteImport } from './routes/embed.$username.$slug'
import { Route as LineAppConnectionIdRouteImport } from './routes/line.app.$connectionId'
import { Route as AppBookingBookingsIndexRouteImport } from './routes/app/booking/bookings.index'
import { Route as AppBookingBookingsIdRouteImport } from './routes/app/booking/bookings.$id'
import { Route as AppBookingEventTypesIdRouteImport } from './routes/app/booking/event-types.$id'
import { Route as LineAppConnectionIdIndexRouteImport } from './routes/line.app.$connectionId.index'
import { Route as LineAppConnectionIdBookingsRouteImport } from './routes/line.app.$connectionId.bookings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const UsernameIndexRoute = UsernameIndexRouteImport.update({
  id: '/$username/',
  path: '/$username/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsernameSlugRoute = UsernameSlugRouteImport.update({
  id: '/$username/$slug',
  path: '/$username/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingRoute = AppBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppWelcomeRoute = AppWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AppRoute,
} as any)
const BookingTokenRoute = BookingTokenRouteImport.update({
  id: '/booking/$token',
  path: '/booking/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ICodeRoute = ICodeRouteImport.update({
  id: '/i/$code',
  path: '/i/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationTokenRoute = InvitationTokenRouteImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LineSpikeRoute = LineSpikeRouteImport.update({
  id: '/line/spike',
  path: '/line/spike',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLinkRoute = LoginLinkRouteImport.update({
  id: '/login_/link',
  path: '/login/link',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAgreementsIndexRoute = AppAgreementsIndexRouteImport.update({
  id: '/agreements/',
  path: '/agreements/',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingIndexRoute = AppBookingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingAvailabilityRoute = AppBookingAvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingCalendarsRoute = AppBookingCalendarsRouteImport.update({
  id: '/calendars',
  path: '/calendars',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingInvitesRoute = AppBookingInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingPaymentsRoute = AppBookingPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppInquiryIndexRoute = AppInquiryIndexRouteImport.update({
  id: '/inquiry/',
  path: '/inquiry/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicingIndexRoute = AppInvoicingIndexRouteImport.update({
  id: '/invoicing/',
  path: '/invoicing/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsActivityRoute = AppSettingsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const EmbedUsernameSlugRoute = EmbedUsernameSlugRouteImport.update({
  id: '/embed/$username/$slug',
  path: '/embed/$username/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const LineAppConnectionIdRoute = LineAppConnectionIdRouteImport.update({
  id: '/line/app/$connectionId',
  path: '/line/app/$connectionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBookingBookingsIndexRoute = AppBookingBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingBookingsIdRoute = AppBookingBookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => AppBookingRoute,
} as any)
const AppBookingEventTypesIdRoute = AppBookingEventTypesIdRouteImport.update({
  id: '/event-types/$id',
  path: '/event-types/$id',
  getParentRoute: () => AppBookingRoute,
} as any)
const LineAppConnectionIdIndexRoute =
  LineAppConnectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LineAppConnectionIdRoute,
  } as any)
const LineAppConnectionIdBookingsRoute =
  LineAppConnectionIdBookingsRouteImport.update({
    id: '/bookings',
    path: '/bookings',
    getParentRoute: () => LineAppConnectionIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/$username/$slug': typeof UsernameSlugRoute
  '/app/billing': typeof AppBillingRoute
  '/app/booking': typeof AppBookingRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/welcome': typeof AppWelcomeRoute
  '/booking/$token': typeof BookingTokenRoute
  '/i/$code': typeof ICodeRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/line/spike': typeof LineSpikeRoute
  '/login/link': typeof LoginLinkRoute
  '/$username/': typeof UsernameIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/booking/availability': typeof AppBookingAvailabilityRoute
  '/app/booking/calendars': typeof AppBookingCalendarsRoute
  '/app/booking/invites': typeof AppBookingInvitesRoute
  '/app/booking/payments': typeof AppBookingPaymentsRoute
  '/app/settings/activity': typeof AppSettingsActivityRoute
  '/app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/embed/$username/$slug': typeof EmbedUsernameSlugRoute
  '/line/app/$connectionId': typeof LineAppConnectionIdRouteWithChildren
  '/app/agreements/': typeof AppAgreementsIndexRoute
  '/app/booking/': typeof AppBookingIndexRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/inquiry/': typeof AppInquiryIndexRoute
  '/app/invoicing/': typeof AppInvoicingIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/booking/bookings/$id': typeof AppBookingBookingsIdRoute
  '/app/booking/event-types/$id': typeof AppBookingEventTypesIdRoute
  '/line/app/$connectionId/bookings': typeof LineAppConnectionIdBookingsRoute
  '/app/booking/bookings/': typeof AppBookingBookingsIndexRoute
  '/line/app/$connectionId/': typeof LineAppConnectionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/$username/$slug': typeof UsernameSlugRoute
  '/app/billing': typeof AppBillingRoute
  '/app/welcome': typeof AppWelcomeRoute
  '/booking/$token': typeof BookingTokenRoute
  '/i/$code': typeof ICodeRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/line/spike': typeof LineSpikeRoute
  '/login/link': typeof LoginLinkRoute
  '/$username': typeof UsernameIndexRoute
  '/app': typeof AppIndexRoute
  '/app/booking/availability': typeof AppBookingAvailabilityRoute
  '/app/booking/calendars': typeof AppBookingCalendarsRoute
  '/app/booking/invites': typeof AppBookingInvitesRoute
  '/app/booking/payments': typeof AppBookingPaymentsRoute
  '/app/settings/activity': typeof AppSettingsActivityRoute
  '/app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/embed/$username/$slug': typeof EmbedUsernameSlugRoute
  '/app/agreements': typeof AppAgreementsIndexRoute
  '/app/booking': typeof AppBookingIndexRoute
  '/app/clients': typeof AppClientsIndexRoute
  '/app/inquiry': typeof AppInquiryIndexRoute
  '/app/invoicing': typeof AppInvoicingIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/booking/bookings/$id': typeof AppBookingBookingsIdRoute
  '/app/booking/event-types/$id': typeof AppBookingEventTypesIdRoute
  '/line/app/$connectionId/bookings': typeof LineAppConnectionIdBookingsRoute
  '/app/booking/bookings': typeof AppBookingBookingsIndexRoute
  '/line/app/$connectionId': typeof LineAppConnectionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/$username/$slug': typeof UsernameSlugRoute
  '/app/billing': typeof AppBillingRoute
  '/app/booking': typeof AppBookingRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/welcome': typeof AppWelcomeRoute
  '/booking/$token': typeof BookingTokenRoute
  '/i/$code': typeof ICodeRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/line/spike': typeof LineSpikeRoute
  '/login_/link': typeof LoginLinkRoute
  '/$username/': typeof UsernameIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/booking/availability': typeof AppBookingAvailabilityRoute
  '/app/booking/calendars': typeof AppBookingCalendarsRoute
  '/app/booking/invites': typeof AppBookingInvitesRoute
  '/app/booking/payments': typeof AppBookingPaymentsRoute
  '/app/settings/activity': typeof AppSettingsActivityRoute
  '/app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/embed/$username/$slug': typeof EmbedUsernameSlugRoute
  '/line/app/$connectionId': typeof LineAppConnectionIdRouteWithChildren
  '/app/agreements/': typeof AppAgreementsIndexRoute
  '/app/booking/': typeof AppBookingIndexRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/inquiry/': typeof AppInquiryIndexRoute
  '/app/invoicing/': typeof AppInvoicingIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/booking/bookings/$id': typeof AppBookingBookingsIdRoute
  '/app/booking/event-types/$id': typeof AppBookingEventTypesIdRoute
  '/line/app/$connectionId/bookings': typeof LineAppConnectionIdBookingsRoute
  '/app/booking/bookings/': typeof AppBookingBookingsIndexRoute
  '/line/app/$connectionId/': typeof LineAppConnectionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/$username/$slug'
    | '/app/billing'
    | '/app/booking'
    | '/app/settings'
    | '/app/welcome'
    | '/booking/$token'
    | '/i/$code'
    | '/invitation/$token'
    | '/line/spike'
    | '/login/link'
    | '/$username/'
    | '/app/'
    | '/app/booking/availability'
    | '/app/booking/calendars'
    | '/app/booking/invites'
    | '/app/booking/payments'
    | '/app/settings/activity'
    | '/app/settings/integrations'
    | '/app/settings/members'
    | '/embed/$username/$slug'
    | '/line/app/$connectionId'
    | '/app/agreements/'
    | '/app/booking/'
    | '/app/clients/'
    | '/app/inquiry/'
    | '/app/invoicing/'
    | '/app/settings/'
    | '/app/booking/bookings/$id'
    | '/app/booking/event-types/$id'
    | '/line/app/$connectionId/bookings'
    | '/app/booking/bookings/'
    | '/line/app/$connectionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/$username/$slug'
    | '/app/billing'
    | '/app/welcome'
    | '/booking/$token'
    | '/i/$code'
    | '/invitation/$token'
    | '/line/spike'
    | '/login/link'
    | '/$username'
    | '/app'
    | '/app/booking/availability'
    | '/app/booking/calendars'
    | '/app/booking/invites'
    | '/app/booking/payments'
    | '/app/settings/activity'
    | '/app/settings/integrations'
    | '/app/settings/members'
    | '/embed/$username/$slug'
    | '/app/agreements'
    | '/app/booking'
    | '/app/clients'
    | '/app/inquiry'
    | '/app/invoicing'
    | '/app/settings'
    | '/app/booking/bookings/$id'
    | '/app/booking/event-types/$id'
    | '/line/app/$connectionId/bookings'
    | '/app/booking/bookings'
    | '/line/app/$connectionId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/$username/$slug'
    | '/app/billing'
    | '/app/booking'
    | '/app/settings'
    | '/app/welcome'
    | '/booking/$token'
    | '/i/$code'
    | '/invitation/$token'
    | '/line/spike'
    | '/login_/link'
    | '/$username/'
    | '/app/'
    | '/app/booking/availability'
    | '/app/booking/calendars'
    | '/app/booking/invites'
    | '/app/booking/payments'
    | '/app/settings/activity'
    | '/app/settings/integrations'
    | '/app/settings/members'
    | '/embed/$username/$slug'
    | '/line/app/$connectionId'
    | '/app/agreements/'
    | '/app/booking/'
    | '/app/clients/'
    | '/app/inquiry/'
    | '/app/invoicing/'
    | '/app/settings/'
    | '/app/booking/bookings/$id'
    | '/app/booking/event-types/$id'
    | '/line/app/$connectionId/bookings'
    | '/app/booking/bookings/'
    | '/line/app/$connectionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  UsernameSlugRoute: typeof UsernameSlugRoute
  BookingTokenRoute: typeof BookingTokenRoute
  ICodeRoute: typeof ICodeRoute
  InvitationTokenRoute: typeof InvitationTokenRoute
  LineSpikeRoute: typeof LineSpikeRoute
  LoginLinkRoute: typeof LoginLinkRoute
  UsernameIndexRoute: typeof UsernameIndexRoute
  EmbedUsernameSlugRoute: typeof EmbedUsernameSlugRoute
  LineAppConnectionIdRoute: typeof LineAppConnectionIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$username/': {
      id: '/$username/'
      path: '/$username'
      fullPath: '/$username/'
      preLoaderRoute: typeof UsernameIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$username/$slug': {
      id: '/$username/$slug'
      path: '/$username/$slug'
      fullPath: '/$username/$slug'
      preLoaderRoute: typeof UsernameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/billing': {
      id: '/app/billing'
      path: '/billing'
      fullPath: '/app/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/booking': {
      id: '/app/booking'
      path: '/booking'
      fullPath: '/app/booking'
      preLoaderRoute: typeof AppBookingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/welcome': {
      id: '/app/welcome'
      path: '/welcome'
      fullPath: '/app/welcome'
      preLoaderRoute: typeof AppWelcomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/booking/$token': {
      id: '/booking/$token'
      path: '/booking/$token'
      fullPath: '/booking/$token'
      preLoaderRoute: typeof BookingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$code': {
      id: '/i/$code'
      path: '/i/$code'
      fullPath: '/i/$code'
      preLoaderRoute: typeof ICodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation/$token': {
      id: '/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof InvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/line/spike': {
      id: '/line/spike'
      path: '/line/spike'
      fullPath: '/line/spike'
      preLoaderRoute: typeof LineSpikeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/link': {
      id: '/login_/link'
      path: '/login/link'
      fullPath: '/login/link'
      preLoaderRoute: typeof LoginLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agreements/': {
      id: '/app/agreements/'
      path: '/agreements'
      fullPath: '/app/agreements/'
      preLoaderRoute: typeof AppAgreementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/booking/': {
      id: '/app/booking/'
      path: '/'
      fullPath: '/app/booking/'
      preLoaderRoute: typeof AppBookingIndexRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/availability': {
      id: '/app/booking/availability'
      path: '/availability'
      fullPath: '/app/booking/availability'
      preLoaderRoute: typeof AppBookingAvailabilityRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/calendars': {
      id: '/app/booking/calendars'
      path: '/calendars'
      fullPath: '/app/booking/calendars'
      preLoaderRoute: typeof AppBookingCalendarsRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/invites': {
      id: '/app/booking/invites'
      path: '/invites'
      fullPath: '/app/booking/invites'
      preLoaderRoute: typeof AppBookingInvitesRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/payments': {
      id: '/app/booking/payments'
      path: '/payments'
      fullPath: '/app/booking/payments'
      preLoaderRoute: typeof AppBookingPaymentsRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/clients/': {
      id: '/app/clients/'
      path: '/clients'
      fullPath: '/app/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/inquiry/': {
      id: '/app/inquiry/'
      path: '/inquiry'
      fullPath: '/app/inquiry/'
      preLoaderRoute: typeof AppInquiryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/invoicing/': {
      id: '/app/invoicing/'
      path: '/invoicing'
      fullPath: '/app/invoicing/'
      preLoaderRoute: typeof AppInvoicingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/activity': {
      id: '/app/settings/activity'
      path: '/activity'
      fullPath: '/app/settings/activity'
      preLoaderRoute: typeof AppSettingsActivityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/integrations': {
      id: '/app/settings/integrations'
      path: '/integrations'
      fullPath: '/app/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/members': {
      id: '/app/settings/members'
      path: '/members'
      fullPath: '/app/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/embed/$username/$slug': {
      id: '/embed/$username/$slug'
      path: '/embed/$username/$slug'
      fullPath: '/embed/$username/$slug'
      preLoaderRoute: typeof EmbedUsernameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/line/app/$connectionId': {
      id: '/line/app/$connectionId'
      path: '/line/app/$connectionId'
      fullPath: '/line/app/$connectionId'
      preLoaderRoute: typeof LineAppConnectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/booking/bookings/': {
      id: '/app/booking/bookings/'
      path: '/bookings'
      fullPath: '/app/booking/bookings/'
      preLoaderRoute: typeof AppBookingBookingsIndexRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/bookings/$id': {
      id: '/app/booking/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/app/booking/bookings/$id'
      preLoaderRoute: typeof AppBookingBookingsIdRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/app/booking/event-types/$id': {
      id: '/app/booking/event-types/$id'
      path: '/event-types/$id'
      fullPath: '/app/booking/event-types/$id'
      preLoaderRoute: typeof AppBookingEventTypesIdRouteImport
      parentRoute: typeof AppBookingRoute
    }
    '/line/app/$connectionId/': {
      id: '/line/app/$connectionId/'
      path: '/'
      fullPath: '/line/app/$connectionId/'
      preLoaderRoute: typeof LineAppConnectionIdIndexRouteImport
      parentRoute: typeof LineAppConnectionIdRoute
    }
    '/line/app/$connectionId/bookings': {
      id: '/line/app/$connectionId/bookings'
      path: '/bookings'
      fullPath: '/line/app/$connectionId/bookings'
      preLoaderRoute: typeof LineAppConnectionIdBookingsRouteImport
      parentRoute: typeof LineAppConnectionIdRoute
    }
  }
}

interface AppBookingRouteChildren {
  AppBookingAvailabilityRoute: typeof AppBookingAvailabilityRoute
  AppBookingCalendarsRoute: typeof AppBookingCalendarsRoute
  AppBookingInvitesRoute: typeof AppBookingInvitesRoute
  AppBookingPaymentsRoute: typeof AppBookingPaymentsRoute
  AppBookingIndexRoute: typeof AppBookingIndexRoute
  AppBookingBookingsIdRoute: typeof AppBookingBookingsIdRoute
  AppBookingEventTypesIdRoute: typeof AppBookingEventTypesIdRoute
  AppBookingBookingsIndexRoute: typeof AppBookingBookingsIndexRoute
}

const AppBookingRouteChildren: AppBookingRouteChildren = {
  AppBookingAvailabilityRoute: AppBookingAvailabilityRoute,
  AppBookingCalendarsRoute: AppBookingCalendarsRoute,
  AppBookingInvitesRoute: AppBookingInvitesRoute,
  AppBookingPaymentsRoute: AppBookingPaymentsRoute,
  AppBookingIndexRoute: AppBookingIndexRoute,
  AppBookingBookingsIdRoute: AppBookingBookingsIdRoute,
  AppBookingEventTypesIdRoute: AppBookingEventTypesIdRoute,
  AppBookingBookingsIndexRoute: AppBookingBookingsIndexRoute,
}

const AppBookingRouteWithChildren = AppBookingRoute._addFileChildren(
  AppBookingRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsActivityRoute: typeof AppSettingsActivityRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsActivityRoute: AppSettingsActivityRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppBillingRoute: typeof AppBillingRoute
  AppBookingRoute: typeof AppBookingRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppWelcomeRoute: typeof AppWelcomeRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAgreementsIndexRoute: typeof AppAgreementsIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppInquiryIndexRoute: typeof AppInquiryIndexRoute
  AppInvoicingIndexRoute: typeof AppInvoicingIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,
  AppBookingRoute: AppBookingRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppWelcomeRoute: AppWelcomeRoute,
  AppIndexRoute: AppIndexRoute,
  AppAgreementsIndexRoute: AppAgreementsIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppInquiryIndexRoute: AppInquiryIndexRoute,
  AppInvoicingIndexRoute: AppInvoicingIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface LineAppConnectionIdRouteChildren {
  LineAppConnectionIdBookingsRoute: typeof LineAppConnectionIdBookingsRoute
  LineAppConnectionIdIndexRoute: typeof LineAppConnectionIdIndexRoute
}

const LineAppConnectionIdRouteChildren: LineAppConnectionIdRouteChildren = {
  LineAppConnectionIdBookingsRoute: LineAppConnectionIdBookingsRoute,
  LineAppConnectionIdIndexRoute: LineAppConnectionIdIndexRoute,
}

const LineAppConnectionIdRouteWithChildren =
  LineAppConnectionIdRoute._addFileChildren(LineAppConnectionIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  UsernameSlugRoute: UsernameSlugRoute,
  BookingTokenRoute: BookingTokenRoute,
  ICodeRoute: ICodeRoute,
  InvitationTokenRoute: InvitationTokenRoute,
  LineSpikeRoute: LineSpikeRoute,
  LoginLinkRoute: LoginLinkRoute,
  UsernameIndexRoute: UsernameIndexRoute,
  EmbedUsernameSlugRoute: EmbedUsernameSlugRoute,
  LineAppConnectionIdRoute: LineAppConnectionIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
